import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './../shared/ApiService/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class OpportunityService {

  public _keyword = undefined;
  public _estKeyWord = undefined;

  constructor(
    private apiService: ApiService) { }

  set keyWord(_keyword) {
    this._keyword = _keyword;
  }

  get keyWord() {
    return this._keyword;
  }

  set estKeyWord(key) {
    this._estKeyWord = key;
  }
  get estKeyWord() {
    return this._estKeyWord;
  }

  allOpportunities(page: any, page_size, search?, location?, courseType?,estaBlishName?,gender?,is_pwd?,sectorId?,qual?,stipendfrom?,upto?, candidateId?) {
    let getUrl = '';
    getUrl = `${environment.base_url + '/opportunities/search?page=' + parseInt(page, 0) + '&page_size=' + parseInt(page_size, 0)}`;
    getUrl += (search && search !== '') ? '&search=' + search : '';
    getUrl += (courseType && courseType !== '') ? '&course_type=' + courseType : '';
    getUrl += (estaBlishName && estaBlishName !== '') ? `&establishment_name=${estaBlishName}` : '';
    if (location && location.length !== 0) {
      for (let i = 0; i < location.length; i++) {
        getUrl += '&locations[' + i + '][type]' + '=' + location[i].type;
        getUrl += '&locations[' + i + '][id]' + '=' + location[i].id;
      }
    } else {
      getUrl += '';
    }

    if(gender){
      getUrl += '&gender=' + gender ;
    }
    if([0, 1].includes(is_pwd)){
      getUrl += '&is_pwd=' + is_pwd ;
    }
    if(sectorId){
      getUrl += '&sector_id=' + sectorId ; 
    }
    if(qual){
      getUrl += '&minqualification=' + qual ; 
    }

    if(stipendfrom && !upto){
      getUrl += '&stipend_from=' + stipendfrom + '&stipend_upto=' + 100000 ; 
    }
    // if(!stipendfrom){
    //   getUrl += '&stipend_from=' + 0 ; 
    // }
    if(!stipendfrom && upto){
      getUrl += '&stipend_from=' + 0 + '&stipend_upto=' + upto ; 
    }
    if(upto && stipendfrom){
      getUrl += '&stipend_from=' + stipendfrom + '&stipend_upto=' + upto  ; 
    }
    if(candidateId){
      getUrl += '&candidate_id=' + candidateId;
    }
   

    return this.apiService.get(getUrl);
  }

  viewOpportunity(id: any) {
    const view = `${environment.base_url}/opportunities/${id}`;
    return this.apiService.get(view);
  }

  searchLocations(term: string = null) {
    const getUrl = `${environment.base_url}/districts?search=${term}`;
    return this.apiService.get(getUrl);
  }

  applyOpportunity(id: any, data: any) {
    const apply = `${environment.base_url}/opportunities/${id}/apply`;
    return this.apiService.post(apply, data);
  }

  /*-----------Get ALll Published Courses---------------*/
  allOptionalCourses(page?: any, page_size?: any, search?: any, sector?: any, exportFlag?: Boolean) {
    let getUserUrl = '';
    // tslint:disable-next-line:max-line-length
    getUserUrl = `${environment.base_url + '/courses/type/optional?' + 'page=' + page + '&page_size=' + page_size + '&search=' + search}&sector=${sector}`;
    if (exportFlag) {
      getUserUrl += `&export=${exportFlag}`;
    }
    return this.apiService.get(getUserUrl);
  }
  allCourses(page?: any, page_size?: any, search?: any, sector?: any, trade?: any, exportFlag?: Boolean) {
    let getUserUrl = '';
    // tslint:disable-next-line:max-line-length
    getUserUrl = `${environment.base_url + '/courses/type/all?' + 'page=' + page + '&page_size=' + page_size + '&search=' + search}&sector=${sector}&type=${trade}`;
    if (exportFlag) {
      getUserUrl += `&export=${exportFlag}`;
    }
    return this.apiService.get(getUserUrl);
  }
  allDesignatedCourses(page?: any, page_size?: any, search?: any, sector?: any, exportFlag?: Boolean) {
    let getUserUrl = '';
    // tslint:disable-next-line:max-line-length
    getUserUrl = `${environment.base_url + '/courses/type/designated?' + 'page=' + page + '&page_size=' + page_size + '&search=' + search}&sector=${sector}`;
    if (exportFlag) {
      getUserUrl += `&export=${exportFlag}`;
    }
    return this.apiService.get(getUserUrl);
  }

  searchApprovedCourses(page_size = 9999, searchTerm?: any): Observable<any> {
    const listCoursesUrl = `${environment.base_url + '/course-list?' + 'page_size=' + page_size + '&status=1' + '&approval_status=approved'}`;
    return this.apiService.get(listCoursesUrl);
  }

  getAllSectorList(): Observable<any> {
    const allSectors = `${environment.base_url}/sectors?page=1&page_size=9999`;
    return this.apiService.get(allSectors);
  }
}
